import ServiceOptionRefund from '@/views/ServiceOptionRefund/index.vue'

const ServiceOptionRefundRouter = {
  path: '/service-option-refund',
  name: 'ServiceOptionRefund',
  component: ServiceOptionRefund,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ServiceOptionRefundRouter
